import { getConfig } from '@klpkonsern/appconfig';

export const KommentarerModuleName = 'comments';

export const kommentarerAccess = (): boolean =>
    getConfig('WEBAPP_KOMMENTARER_ENABLE') || false;

export const byggApiName = 'bygg';
export const kommentarerApiName = 'kommentar';
